import React, { useState } from "react";
import "./Careers.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

export default function Careers() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", role: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Please enter your name.";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errs.email = "Please enter a valid email address.";
    const digits = form.phone.replace(/\D/g, "").slice(-10);
    if (!/^[6-9]\d{9}$/.test(digits)) errs.phone = "Please enter a valid 10-digit phone number.";
    if (!form.message.trim()) errs.message = "Please tell us about yourself.";
    return errs;
  };

  const update = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  };

  const submit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setStatus("sending");
    try {
      const res = await fetch(`${BACKEND_URL}/api/careers/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("failed");
      setStatus("sent");
      setForm({ name: "", email: "", phone: "", role: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="careers-page">
      <section className="careers-hero">
        <span className="section-label">Careers</span>
        <h1>Grow with the mountains</h1>
        <p>
          PureJar is a young venture with big roots. If our story of bringing
          Pahadi flavors to the nation excites you, we'd love to hear from you —
          whatever your craft.
        </p>
      </section>

      {status === "sent" ? (
        <div className="careers-thanks">
          <h3>Application received 🌿</h3>
          <p>Thank you! We'll be in touch at the email you provided.</p>
        </div>
      ) : (
        <form className="careers-form" onSubmit={submit}>
          <label>Full name<input name="name" value={form.name} onChange={update} />{errors.name && <span className="field-error">{errors.name}</span>}</label>
          <label>Email<input name="email" type="email" value={form.email} onChange={update} />{errors.email && <span className="field-error">{errors.email}</span>}</label>
          <label>Phone<input name="phone" placeholder="10-digit mobile" value={form.phone} onChange={update} />{errors.phone && <span className="field-error">{errors.phone}</span>}</label>
          <label>Role you're interested in<input name="role" placeholder="e.g. Business Development, Design, Operations" value={form.role} onChange={update} /></label>
          <label>Tell us about yourself<textarea name="message" rows="5" value={form.message} onChange={update} placeholder="A few lines about you, your experience, and a link to your resume/LinkedIn if you have one." />{errors.message && <span className="field-error">{errors.message}</span>}</label>
          <button className="careers-submit" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Apply"}
          </button>
          {status === "error" && <p className="careers-error">Something went wrong — please try again, or email us directly at careers@purejar.in</p>}
        </form>
      )}

      <p className="careers-direct">Prefer email? Write to <a href="mailto:careers@purejar.in">careers@purejar.in</a></p>
    </div>
  );
}
